import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import moment from "moment";
import { MARKETS, PACKAGING_TYPES } from "pages/development/consts";
import { useState } from "react";
import { GTM_PROJECT_SAVE_PACKAGING } from "../graphql";

const defaultValues = {
  name: "",
  market: MARKETS[0],
  variants: "",
  packagingType: PACKAGING_TYPES[0],
  usePDQ: false,
  useFloorDisplay: false,
  floorDisplayType: "UNSET",
  qtyPerCarton: 20,
  trademark: "",
  age: 8,
  orderQty: 10000,
};

const PackagingBaseInfoForm = ({
  gtmProjectId,
  packagingId,
  originalBasicInfo = {},
  onSave,
}) => {
  const [basicInfo, setBasicInfo] = useState({
    ...defaultValues,
    ...originalBasicInfo,
  });
  const [save, saveRes] = useMutation(GTM_PROJECT_SAVE_PACKAGING, {
    onCompleted() {
      Alert("success", "Packaging information saved.");
      onSave();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  function saveHandler() {
    save({
      variables: {
        gtmProjectId,
        packagingId,
        basic: JSON.stringify(basicInfo, " ", 2),
      },
    });
  }

  return (
    <div>
      <div className="-mx-2">
        <table className="whitespace-nowrap">
          <tbody>
            <tr>
              <td>
                <label htmlFor="">Name:</label>
              </td>
              <td>
                <Input
                  placeholder={`e.g. ${moment().year() + 1} Surfing Board Packaging`}
                  className="w-full"
                  value={basicInfo.name}
                  onChange={(e) =>
                    setBasicInfo({ ...basicInfo, name: e.target.value })
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Market:</label>
              </td>
              <td className="w-full">
                <Select
                  value={basicInfo.market}
                  onChange={(e) =>
                    setBasicInfo({ ...basicInfo, market: e.target.value })
                  }
                >
                  {MARKETS.map((market) => (
                    <option key={market} value={market}>
                      {market}
                    </option>
                  ))}
                </Select>
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="">Variants:</label>
              </td>
              <td>
                <Input
                  placeholder="e.g: Snakeskin  - Green, Fire sparks - Orange, Purple waves - PurpleRed."
                  className="w-full"
                  value={basicInfo.variants}
                  onChange={(e) =>
                    setBasicInfo({ ...basicInfo, variants: e.target.value })
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="">Packaging Type:</label>
              </td>
              <td>
                <Select
                  value={basicInfo.packagingType}
                  onChange={(e) =>
                    setBasicInfo({
                      ...basicInfo,
                      packagingType: e.target.value,
                    })
                  }
                >
                  {PACKAGING_TYPES.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </Select>
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="">Use PDQ: </label>
              </td>
              <td className="space-x-3">
                <input
                  type="checkbox"
                  checked={basicInfo.usePDQ}
                  onChange={(e) =>
                    setBasicInfo({ ...basicInfo, usePDQ: e.target.checked })
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="">Use Floor Display: </label>
              </td>
              <td className="space-x-3">
                <input
                  type="checkbox"
                  checked={basicInfo.useFloorDisplay}
                  onChange={(e) =>
                    setBasicInfo({
                      ...basicInfo,
                      useFloorDisplay: e.target.checked,
                    })
                  }
                />

                {basicInfo.useFloorDisplay && (
                  <Select
                    value={basicInfo.floorDisplayType}
                    onChange={(e) =>
                      setBasicInfo({
                        ...basicInfo,
                        floorDisplayType: e.target.value,
                      })
                    }
                  >
                    <option value="UNSET" disabled>
                      How to Display
                    </option>
                    <option value="Hang">Hang</option>
                    <option value="Put">Put</option>
                  </Select>
                )}
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="">QTY Per Carton: </label>
              </td>
              <td className="space-x-3">
                <Input
                  className="w-20"
                  placeholder="Quantity"
                  value={basicInfo.qtyPerCarton}
                  onChange={(e) =>
                    setBasicInfo({
                      ...basicInfo,
                      qtyPerCarton: Number(e.target.value),
                    })
                  }
                />
                <span>/ Carton</span>
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="">Trademark / Legal Name: </label>
              </td>
              <td>
                <Input
                  placeholder="Waboba XXX"
                  className="w-full"
                  value={basicInfo.trademark}
                  onChange={(e) =>
                    setBasicInfo({ ...basicInfo, trademark: e.target.value })
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="">Age Grading: </label>
              </td>
              <td>
                <Input
                  className="w-20"
                  placeholder="Age"
                  value={basicInfo.age}
                  onChange={(e) =>
                    setBasicInfo({
                      ...basicInfo,
                      age: Number(e.target.value),
                    })
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr />

      <div>
        <Button primary onClick={saveHandler} loading={saveRes.loading}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default PackagingBaseInfoForm;
